const COUNTRY_CODES_BY_LANGUAGE = {
  vi: ['VN'],
  en: ['AG', 'AU', 'BS', 'BB', 'BZ', 'BW', 'CA', 'DM', 'FJ', 'GM', 'GH', 'GD', 'GY', 'IE', 'JM', 'KE', 'LR', 'MT', 'MU', 'NA', 'NZ', 'NG', 'PH', 'RW', 'SG', 'ZA', 'TZ', 'TT', 'UG', 'GB', 'US', 'ZM', 'ZW'],
  af: ['ZA', 'NA'],
  ar: ['DZ', 'BH', 'TD', 'KM', 'DJ', 'EG', 'IQ', 'JO', 'KW', 'LB', 'LY', 'MR', 'MA', 'OM', 'PS', 'QA', 'SA', 'SO', 'SD', 'SY', 'TN', 'AE', 'YE'],
  bn: ['BD', 'IN'],
  zh: ['CN', 'SG'],
  'zh-tw': ['TW', 'HK', 'MO'],
  tl: ['PH'],
  fr: ['FR', 'BE', 'BJ', 'BF', 'BI', 'CM', 'CA', 'CF', 'TD', 'KM', 'CD', 'CG', 'CI', 'DJ', 'GQ', 'GA', 'GN', 'HT', 'LU', 'MG', 'ML', 'MC', 'NE', 'RW', 'SN', 'SC', 'CH', 'TG', 'VU'],
  de: ['DE', 'AT', 'CH', 'LI', 'LU', 'BE'],
  ha: ['NG', 'NE'],
  hi: ['IN'],
  id: ['ID'],
  it: ['IT', 'CH', 'SM', 'VA'],
  ja: ['JP'],
  km: ['KH'],
  ko: ['KR', 'KP'],
  lo: ['LA'],
  ms: ['MY', 'BN', 'SG'],
  mm: ['MM'],
  my: ['MM'],
  pt: ['PT', 'BR', 'AO', 'CV', 'GW', 'MZ', 'ST', 'TL'],
  ru: ['RU', 'BY', 'KZ', 'KG'],
  es: ['ES', 'AR', 'BO', 'CL', 'CO', 'CR', 'CU', 'DO', 'EC', 'SV', 'GQ', 'GT', 'HN', 'MX', 'NI', 'PA', 'PY', 'PE', 'UY', 'VE'],
  sw: ['TZ', 'KE', 'UG', 'RW', 'CD'],
  th: ['TH'],
  tr: ['TR', 'CY'],
  ur: ['PK', 'IN']
};

const FALLBACK_LANGUAGE_NAMES = {
  vi: 'Tiếng Việt',
  en: 'Tiếng Anh',
  af: 'Tiếng Afrikaans',
  ar: 'Tiếng Ả Rập',
  bn: 'Tiếng Bengal',
  zh: 'Tiếng Trung giản thể',
  'zh-tw': 'Tiếng Trung phồn thể',
  tl: 'Tiếng Philippines',
  fr: 'Tiếng Pháp',
  de: 'Tiếng Đức',
  ha: 'Tiếng Hausa',
  hi: 'Tiếng Hindi',
  id: 'Tiếng Indonesia',
  it: 'Tiếng Ý',
  ja: 'Tiếng Nhật',
  km: 'Tiếng Khmer',
  ko: 'Tiếng Hàn',
  lo: 'Tiếng Lào',
  ms: 'Tiếng Malaysia',
  mm: 'Tiếng Myanmar',
  my: 'Tiếng Myanmar',
  pt: 'Tiếng Bồ Đào Nha',
  ru: 'Tiếng Nga',
  es: 'Tiếng Tây Ban Nha',
  sw: 'Tiếng Swahili',
  th: 'Tiếng Thái',
  tr: 'Tiếng Thổ Nhĩ Kỳ',
  ur: 'Tiếng Urdu'
};

const regionNames = typeof Intl !== 'undefined' && Intl.DisplayNames
  ? new Intl.DisplayNames(['vi'], { type: 'region' })
  : null;

export const normalizeLanguageCode = (value = '') => String(value).trim().toLowerCase();

export const SUPPORTED_POPUP_LANGUAGE_CODES = [
  'af',
  'ar',
  'bn',
  'zh',
  'zh-TW',
  'en',
  'tl',
  'fr',
  'de',
  'ha',
  'hi',
  'id',
  'it',
  'ja',
  'km',
  'ko',
  'lo',
  'ms',
  'mm',
  'pt',
  'ru',
  'es',
  'sw',
  'th',
  'tr',
  'ur',
  'vi'
];

export const SUPPORTED_POPUP_LANGUAGES = SUPPORTED_POPUP_LANGUAGE_CODES.map(code => ({
  code,
  key: code,
  normalizedCode: normalizeLanguageCode(code),
  name: FALLBACK_LANGUAGE_NAMES[normalizeLanguageCode(code)] || code.toUpperCase()
}));

export const countryFlag = (countryCode = '') => String(countryCode)
  .toUpperCase()
  .replace(/./g, character => String.fromCodePoint(127397 + character.charCodeAt()));

export const countryName = (countryCode = '') => (
  regionNames?.of(String(countryCode).toUpperCase()) || String(countryCode).toUpperCase()
);

export const createStoredCountryOption = (countryCode) => ({
  code: String(countryCode).toUpperCase(),
  name: countryName(countryCode),
  flag: countryFlag(countryCode),
  languageCode: 'saved',
  languageName: 'Quốc gia đã lưu'
});

export const getCountryOptionsForLanguages = (languages = []) => {
  const options = new Map();

  languages.forEach((language) => {
    const languageCode = normalizeLanguageCode(language?.key || language?.code);
    const countryCodes = COUNTRY_CODES_BY_LANGUAGE[languageCode] || [];
    const languageName = language?.name || FALLBACK_LANGUAGE_NAMES[languageCode] || languageCode.toUpperCase();

    countryCodes.forEach((code) => {
      if (!options.has(code)) {
        options.set(code, {
          code,
          name: countryName(code),
          flag: countryFlag(code),
          languageCode,
          languageName
        });
      }
    });
  });

  return Array.from(options.values()).sort((first, second) => (
    first.languageName.localeCompare(second.languageName, 'vi')
    || first.name.localeCompare(second.name, 'vi')
  ));
};
